// extracted by mini-css-extract-plugin
module.exports = {"wrapInfo":"InfoBlock_wrapInfo__1Sc32","wrapItem":"InfoBlock_wrapItem__3HoZV","moreInfo":"InfoBlock_moreInfo__3Fcub"};